import { useIntl } from '@leagueplatform/locales';
import {
  GDSHTMLTagOptions,
  Image,
  ParagraphText,
  StackItem,
  UtilityText,
} from '@leagueplatform/genesis-core';
import { StepScreen } from 'components/step-screen/step-screen.component';
import AccountSetupSuccessIconMyHealth from 'assets/my-health/account-setup-success.png';
import { STEP_STRING_IDS } from 'components/onboarding-account-setup/onboarding-account-setup.constants';
import { useNavigate } from 'react-router-dom';
import { EVENT_NAME } from '@leagueplatform/analytics';
import { ANALYTICS_SCREEN_NAMES, ANALYTICS_DETAILS } from 'common/constants';
import { useOnboardingAnalytics } from 'hooks/use-onboarding-analytics/use-onboarding-analytics.hook';

export const MyHealthCompleteStep = ({
  onComplete,
}: {
  onComplete: () => void;
}) => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const trackEvent = useOnboardingAnalytics(
    ANALYTICS_SCREEN_NAMES.ACCOUNT_SETUP_COMPLETE,
  );

  const BodyTextHtmlTagOptions: GDSHTMLTagOptions = {
    p: {
      component: UtilityText,
      props: {
        emphasis: 'emphasized',
      },
    },
    li: {
      component: UtilityText,
      props: {
        as: 'li',
        emphasis: 'subtle',
      },
    },
  };

  return (
    <StepScreen
      headerContent={
        <Image src={AccountSetupSuccessIconMyHealth} width="160" height="160" />
      }
      heading={formatMessage({ id: STEP_STRING_IDS.complete.heading })}
      subHeading={formatMessage({ id: STEP_STRING_IDS.complete.subHeading })}
      primaryButton={{
        label: formatMessage({
          id: STEP_STRING_IDS.complete.primaryButtonLabel,
        }),
        onClick: () => {
          trackEvent(EVENT_NAME.BUTTON_CLICKED, {
            detail: ANALYTICS_DETAILS.NAVIGATE_TO_ADD_A_CLINIC,
          });
          onComplete();
          navigate('/link-centre');
        },
      }}
      secondaryButton={{
        label: formatMessage({
          id: STEP_STRING_IDS.complete.secondaryButtonLabel,
        }),
        onClick: () => {
          trackEvent(EVENT_NAME.BUTTON_CLICKED, {
            detail: ANALYTICS_DETAILS.NAVIGATE_TO_HOME,
          });
          onComplete();
          navigate('/home');
        },
      }}
    >
      <ParagraphText
        as={StackItem}
        htmlStringOptions={BodyTextHtmlTagOptions}
        css={{ gap: '$half', marginBlockEnd: '$none !important' }}
      >
        {formatMessage({ id: STEP_STRING_IDS.complete.body })}
      </ParagraphText>
    </StepScreen>
  );
};
